import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initTelemetry } from "~/telemetry";

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Task 5.5: bootstrap diferido, disparado só depois da renderização inicial
// para não bloquear o primeiro paint (Req 10.9/10.12); gated por
// VITE_TELEMETRY_ENABLED e fail-open dentro de initTelemetry().
void initTelemetry();
